import IUserProfileResponse from '#/types/API/userProfile';
import withMatcher from '#/utils/withMatcher';

export const createActionProfileAddProfile = withMatcher(
  (payload: IUserProfileResponse) => {
    return {
      type: 'profile/add_profile',
      payload,
    };
  }
);

export const createActionProfileRemoveProfile = withMatcher(() => {
  return {
    type: 'profile/remove_profile',
  };
});
